export default "__VITE_ASSET__DvucqgwR__"